<template>
  <v-flex xs12 sm8 md4>
    <v-alert :type="message" dismissible v-model="alert">
      {{ alertMessages[message] }}
    </v-alert>
    <v-card class="elevation-12">

      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form>
          <v-text-field
            prepend-icon="person"
            name="login"
            label="Email"
            type="text"
            v-model="email"
            :error-messages="errors.email"
            :error="error"
          >
          </v-text-field>
          <v-text-field
            prepend-icon="lock"
            name="password"
            label="Password"
            type="password"
            v-model="password"
            :error-messages="errors.password"
            :error="error"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <a
          @click="register()"
        >
          New user? Register
        </a>
        <v-btn
          color="primary"
          @click="login()"
          :loading="loading"
        >
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
  import mixinsPages from '@/mixins/pages'
  import * as auth from '@/services/auth'

  export default {
    mixins: [mixinsPages],
    data () {
      return {
        email: '',
        password: '',
        loading: false,
        errors: {
          email: [],
          password: []
        },
        error: false,
        message: null,
        alert: false,
        alertMessages: {
          success: 'Account has been successfully activated',
          error: 'Error occurred during account activation',
          warning: 'This account is already activated',
          info: 'Activation link has been sent to your email'
        }
      }
    },
    methods: {
      async login () {
        try {
          this.loading = true
          this.error = false
          const data = await this.$axios.post('login', {
            email: this.email,
            password: this.password
          })
          auth.setUser(data.data)
          this.$router.push({name: 'dashboard'})
        } catch (error) {
          this.errors = error.response.data
          this.error = true
          this.loading = false
        }
      },
      register () {
        this.$router.push({name: 'register'})
      }
    },
    created () {
      this.message = this.$route.query.active
      if (typeof this.message !== 'undefined') {
        this.alert = true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/login.vue